// extracted by mini-css-extract-plugin
export var content = "FAQSection-module--content--cfd07";
export var section = "FAQSection-module--section--6d39c";